(function ($) {
  $(document).ready(function () {

    // footer
    addTargetFooter();

    function addTargetFooter() {
      const linkFooter = $('.footer .container .menu_links .footer__link a');
      linkFooter.map(function (index, ele) {
        const href = $(ele).attr('href');
        if (href.indexOf('.sony.com.vn') > -1) {
          $(ele).attr('target', '_blank');
        }
      })
    }
  })
}(jQuery));
